import { Injectable } from '@angular/core';

@Injectable()
export class CustomizeChartsService {
  getChartData(moduleName: string) {
    let charts = [];
    if (moduleName === 'ticketing') {
      charts = [
        // {
        //   name: 'Expiring and expired tickets',
        //   cardsRequired: 1,
        //   chartType: 'donut',
        //   information:
        //     ' This graph segregates all the tickets to the categories like, tickets expired, expiring in one hour, in four hours, in eight hours and in one day.'
        // },
        {
          name: 'Ticket status distribution',
          cardsRequired: 1,
          chartType: 'sankey',
          information: 'This graph segregates all the tickets according to the status of the tickets.'
        },
        {
          name: 'Usage of automation',
          cardsRequired: 1,
          chartType: 'sankey',
          information:
            'This graph will show the relative mapping of the tickets solved by Automation solutions according to assignment groups'
        },
        // {
        //   name: 'Tickets per application',
        //   cardsRequired: 1,
        //   chartType: 'sankey',
        //   information: 'This chart segregates all the tickets according to the application value of the ticket. '
        // },
        {
          name: 'Ticket priority',
          cardsRequired: 1,
          chartType: 'pie',
          information: 'This graph segregates all the tickets according to the priority of the tickets.'
        },
        {
          name: 'Tickets resolved',
          cardsRequired: 1,
          chartType: 'count',
          information:
            'This data represents the count of tickets resolved today, yesterday and displays the average count of tickets resolved from last 9 days. '
        },
        {
          name: 'Work items distribution',
          cardsRequired: 1,
          chartType: 'sankey',
          information: 'This chart shows the count of tickets assigned to each user'
        },
        // {
        //   name: 'Most used automation solution',
        //   cardsRequired: 1,
        //   chartType: 'pie',
        //   information: 'This chart shows the count of tickets which used a particular automation solution.'
        // },
        {
          name: 'Most used knowledge objects',
          cardsRequired: 1,
          chartType: 'pie',
          information: 'This chart shows the count of tickets which used a particular knowledge object.'
        }
      ];
    } else if (moduleName === 'automation') {
      charts = [
        { name: 'Percentage of tickets using automation', cardsRequired: 3, chartType: 'column', information: '' },
        {
          name: 'Solution Usage - Tool Type and Assignment Group',
          cardsRequired: 3,
          chartType: 'column',
          information: ''
        },
        {
          name: 'Effort savings by assignment groups',
          cardsRequired: 3,
          chartType: 'column',
          information: ''
        },
        { name: 'Solution utilization by assignment group', cardsRequired: 3, chartType: 'column', information: '' },
        { name: 'Solution usage - ticket count', cardsRequired: 3, chartType: 'column', information: '' },
        { name: 'Effort savings by solutions', cardsRequired: 3, chartType: 'column', information: '' }
      ];
    } else if (moduleName === 'knowledge') {
      charts = [
        { name: 'Most used knowledge objects', cardsRequired: 1, chartType: 'pie', information: '' },
        { name: 'Tickets resolved by knowledge objects', cardsRequired: 1, chartType: 'column', information: '' },
        {
          name: 'Tickets resolved manually and knowledge objects',
          cardsRequired: 1,
          chartType: 'pie',
          information: ''
        },
        {
          name: 'KO Usage by Assignment Group',
          cardsRequired: 3,
          chartType: 'column',
          information: ''
        }
      ];
    } else if (moduleName === 'fma') {
      charts = [
        { name: 'Assignee groups', cardsRequired: 1, chartType: 'pie', information: '' },
        { name: 'Tickets status distribution', cardsRequired: 1, chartType: 'pie', information: '' },
        {
          name: 'Ticket analysis',
          cardsRequired: 1,
          chartType: 'count',
          information: ''
        }
      ];
    } else if (moduleName === 'assessment') {
      charts = [
        { name: 'Analysis Pattern', cardsRequired: 1, chartType: 'donut', information: '' },
        { name: 'Batch status distribution', cardsRequired: 1, chartType: 'pie', information: '' },
        {
          name: 'Assignee group distribution',
          cardsRequired: 1,
          chartType: 'pie',
          information: ''
        }
      ];
    } else if (moduleName === 'aiops new') {
      charts = [
        {
          name: 'System overview',
          cardsRequired: 1,
          chartType: 'count',
          information: 'This chart shows the count of total events, scenarios and alerts'
        },
        {
          name: 'Alerts',
          cardsRequired: 1,
          chartType: 'donut',
          information: 'This graph shows the status distribution of alerts'
        },
        {
          name: 'Scenarios',
          cardsRequired: 1,
          chartType: 'donut',
          information: 'This graph shows the status distribution of scenarios'
        }
      ];
    } else if (moduleName === 'healthcheck') {
      charts = [
        {
          name: 'Healthcheck status applications',
          cardsRequired: 1,
          chartType: 'donut',
          information: 'This chart shows the application distribution of the jobs'
        },
        { name: 'Jobs status distribution', cardsRequired: 1, chartType: 'pie', information: '' },
        {
          name: 'Outcome summary',
          cardsRequired: 1,
          chartType: 'count',
          information: 'This chart shows the status distribution of the jobs'
        },
        {
          name: 'Scheduled applications',
          cardsRequired: 1,
          chartType: 'donut',
          information: 'This chart shows the application distribution of the scheduled jobs'
        },
        {
          name: 'Frequency of jobs',
          cardsRequired: 1,
          chartType: 'pie',
          information: 'This chart shows the frequency of the scheduled jobs'
        },
        {
          name: 'Weekly scheduled jobs',
          cardsRequired: 1,
          chartType: 'column',
          information: 'This chart shows the weekly scheduled jobs'
        }
      ];
    } else if (moduleName === 'dashboard') {
      charts = [
        {
          name: 'Backlog trend',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart shows the trend of tickets not closed, with additional split by status'
        },
        {
          name: 'Daily backlog trend',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart shows the trend of tickets not closed, with additional split by status'
        },
        {
          name: 'Backlog length',
          cardsRequired: 3,
          chartType: 'line',
          information:
            'This chart shows the time it would take to complete all the incidents in the backlog, based on historic productivity levels (throughput of last period)'
        },
        {
          name: 'Backlog index',
          cardsRequired: 3,
          chartType: 'line',
          information:
            'This chart shows the percentage of number of incidents closed during a month per number of incidents arrived during the month'
        },
        {
          name: 'New work items',
          cardsRequired: 3,
          chartType: 'line',
          information: 'This chart shows the number of new tickets raised over time'
        },
        {
          name: 'Throughput',
          cardsRequired: 3,
          chartType: 'line',
          information: 'This chart shows the rate at which tickets are closed/completed, over a given period of time'
        },
        {
          name: 'Pareto analysis by category',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows the ticket count, split by a defined category Items, are sorted and then aggregated in a cumulative way representing the Pareto Distribution or 80 20 analysis'
        },
        {
          name: 'Pareto analysis by status',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows the ticket count, split by a defined status, are sorted and then aggregated in a cumulative way representing the Pareto Distribution or 80 20 analysis'
        },
        {
          name: 'Pareto analysis by priority',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows the ticket count, split by a defined ticket status, are sorted and then aggregated in a cumulative way representing the Pareto Distribution or 80 20 analysis'
        },
        {
          name: 'Pareto analysis by assignee',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows the ticket count, split by a defined team, are sorted and then aggregated in a cumulative way representing the Pareto Distribution or 80 20 analysis'
        },
        {
          name: 'Ageing list consolidated',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart displays the total tickets that are open under each of the ageing group bucket and is an enhanced version of the Ageing chart, the difference being we do not see Ticket status in the query output here'
        },
        {
          name: 'Ageing list by priority',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows how ticket age for those tickets that are open, split by ageing periods and by the ticket priority'
        },
        {
          name: 'Consolidated backlog age',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart plots the trend of average ageing of live/open tickets.'
        },
        {
          name: 'Average backlog age',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart plots the trend of average ageing of live/open tickets. Threshold value is considered as 5'
        },
        /*  ];
        } else if (moduleName === 'sla compliance') {
          charts = [ */
        {
          name: 'Ticket lead time',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows the total elapsed time for all the tickets that have been closed for a given period of time'
        },
        {
          name: 'Resolution sla compliance rate',
          cardsRequired: 3,
          chartType: 'column',
          information: 'Percentage of Resolved Incidents that respected the agreed Resolution time SLAs.'
        },
        {
          name: 'Resolution sla breach rate',
          cardsRequired: 3,
          chartType: 'line',
          information: 'Percentage of Resolved Incidents that did not respect the agreed Resolution time SLAs.'
        },
        {
          name: 'Response sla compliance rate',
          cardsRequired: 3,
          chartType: 'line',
          information: 'Percentage of Responded Incidents that respected the agreed Response SLAs.'
        },
        {
          name: 'Response sla breach rate',
          cardsRequired: 3,
          chartType: 'line',
          information: 'Percentage of Responded Incidents that did not respect the agreed Response SLAs.'
        },
        {
          name: 'SLA SR resolution',
          cardsRequired: 3,
          chartType: 'line',
          information: 'Percentage of Responded Service Requests that respected the agreed Response SLAs.'
        },
        {
          name: 'SLA breach SR resolution',
          cardsRequired: 3,
          chartType: 'column',
          information: 'Percentage of Resolved Service Request that did not respect the agreed Resolution time SLAs.'
        },
        {
          name: 'Team member view',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This view maps Work items by Team Member responsible to their current SLA status'
        },
        {
          name: 'Percentage of tickets using automation',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows month wise distribution of tickets resolved by automation grouped by assignment groups'
        },
        {
          name: 'Solution Usage - Tool Type and Assignment Group',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows month wise distribution of tickets according to solution types and stacked by assignment groups'
        },
        {
          name: 'Effort savings by assignment groups',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows month wise effort saved in minutes by each assignment group by particular solution'
        },
        {
          name: 'Solution utilization by assignment group',
          cardsRequired: 3,
          chartType: 'column',
          information:
            'This chart shows the count of tickets distributed by months using solutions, grouped by assignment group'
        },
        {
          name: 'Solution usage - ticket count',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart shows the count of tickets for each solution used'
        },
        {
          name: 'Effort savings by solutions',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart shows the efforts saved by solution in minutes'
        },
        {
          name: 'Spread of tickets',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart shows total number of work items on a specific day'
        },
        {
          name: 'Work items waterfall by category',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart tracks the distribution of tickets by status and category'
        },
        {
          name: 'Work items waterfall by assignee',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart tracks the distribution of tickets by status and team'
        },
        {
          name: 'Work items waterfall by priority',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart tracks the distribution of tickets by status and priority'
        },
        {
          name: 'Work item distribution by status',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart presents the volume of tickets split by status'
        },
        {
          name: 'Work item distribution by team',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart presents the volume of tickets split by team'
        },
        {
          name: 'Work item distribution by assignee',
          cardsRequired: 3,
          chartType: 'column',
          information: 'This chart presents the volume of tickets split by assignment group'
        }
      ];
    } else if (moduleName === 'execution') {
      charts = [
        { name: 'workflows', cardsRequired: 1, chartType: 'pie', information: '' },
        { name: 'Current status distribution', cardsRequired: 1, chartType: 'pie', information: '' },
        { name: 'Number of executions for project', cardsRequired: 1, chartType: 'pie', information: '' }
      ];
    } else if (moduleName === 'requirements') {
      charts = [
        { name: 'Project features', cardsRequired: 1, chartType: 'column' },
        { name: 'Features status', cardsRequired: 1, chartType: 'column' },
        { name: 'Features priority', cardsRequired: 1, chartType: 'column' }
      ];
    } else if (moduleName === 'healthcheck_new') {
      charts = [
        {
          name: 'Health check schedules',
          cardsRequired: 1,
          chartType: 'column',
          information: 'This chart shows the status of scheduled jobs'
        }
      ];
    }
    return charts;
  }
}
